
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24Price3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.284 21.347a2.083 2.083 0 0 1-1.49.61l-.093.043a2.328 2.328 0 0 1-1.562-.717l-9.42-9.434A2.342 2.342 0 0 1 2 10.143l.151-5.932a2.07 2.07 0 0 1 2.03-2.06L10.139 2a2.313 2.313 0 0 1 1.705.718l9.434 9.411c.427.41.684.966.72 1.557a2.091 2.091 0 0 1-.612 1.578l-6.102 6.083zm-1.526-.825a.656.656 0 0 0 .504-.186l6.11-6.09a.651.651 0 0 0 .186-.503.931.931 0 0 0-.273-.595l-9.448-9.419a.915.915 0 0 0-.648-.273l-5.958.151a.64.64 0 0 0-.64.639l-.152 5.94a.888.888 0 0 0 .274.645l9.448 9.419c.16.16.372.256.597.272z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.368 6.21a2.244 2.244 0 0 0-3.158 0 2.244 2.244 0 0 0 0 3.158 2.244 2.244 0 0 0 3.158 0 2.244 2.244 0 0 0 0-3.157zM7.263 8.317a.733.733 0 0 1 0-1.053.733.733 0 0 1 1.052 0 .733.733 0 0 1 0 1.053.733.733 0 0 1-1.052 0zm11.045 4.744a.744.744 0 1 1 1.053 1.053l-5.249 5.248a.744.744 0 1 1-1.052-1.053l5.248-5.248zm-1.382-2.306a.744.744 0 0 0-.723.2l-5.248 5.249a.744.744 0 1 0 1.052 1.053l5.248-5.249a.744.744 0 0 0-.33-1.253z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"72\" height=\"72\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.284 21.347a2.083 2.083 0 0 1-1.49.61l-.093.043a2.328 2.328 0 0 1-1.562-.717l-9.42-9.434A2.342 2.342 0 0 1 2 10.143l.151-5.932a2.07 2.07 0 0 1 2.03-2.06L10.139 2a2.313 2.313 0 0 1 1.705.718l9.434 9.411c.427.41.684.966.72 1.557a2.091 2.091 0 0 1-.612 1.578l-6.102 6.083zm-1.526-.825a.656.656 0 0 0 .504-.186l6.11-6.09a.651.651 0 0 0 .186-.503.931.931 0 0 0-.273-.595l-9.448-9.419a.915.915 0 0 0-.648-.273l-5.958.151a.64.64 0 0 0-.64.639l-.152 5.94a.888.888 0 0 0 .274.645l9.448 9.419c.16.16.372.256.597.272z\" fill=\"#000000\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.368 6.21a2.244 2.244 0 0 0-3.158 0 2.244 2.244 0 0 0 0 3.158 2.244 2.244 0 0 0 3.158 0 2.244 2.244 0 0 0 0-3.157zM7.263 8.317a.733.733 0 0 1 0-1.053.733.733 0 0 1 1.052 0 .733.733 0 0 1 0 1.053.733.733 0 0 1-1.052 0zm11.045 4.744a.744.744 0 1 1 1.053 1.053l-5.249 5.248a.744.744 0 1 1-1.052-1.053l5.248-5.248zm-1.382-2.306a.744.744 0 0 0-.723.2l-5.248 5.249a.744.744 0 1 0 1.052 1.053l5.248-5.249a.744.744 0 0 0-.33-1.253z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-price@3x.3d2c1a2a3372bed8768c9a99d1c20d6e.svg"),
        {
          React: SvgIcon24Price3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      